// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"f88255e9","221":"9256fa71","307":"6c97f87b","453":"47053a3d","605":"4431202c","810":"c327dcfe","839":"b99f657a","878":"dae3b85e","902":"06b675bd"}[chunkId] + ".chunk.js";
};